import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {
  DROPOFF_NOTE_TEXT,
  formatPickupAddress,
  getInstallationDateLabel,
  NOVUS_PICKUP_ADDRESS,
} from '@components/Checkout/steps/InstallationStep/utils/installationStepUtils';
import type { ViewOnlyProps } from '@components/Checkout/steps/InstallationStep/InstallationStep.types';
import InfoBannerBlock from '@shared/components/feedback/InfoBannerBlock/InfoBannerBlock';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const ViewOnly = ({ savedValues, pickupAddress, restrictionDescription }: ViewOnlyProps) => {
  const isSelf = savedValues?.installationMethod === 'SELF';
  const displayPickupAddress = pickupAddress ? formatPickupAddress(pickupAddress) : '';
  const methodLabel = isSelf ? 'Self-Installation' : 'Technician';
  const deliveryLabel =
    savedValues?.hardwareDelivery === 'PICKUP'
      ? 'Pick up in person at a Novus location'
      : 'Have it delivered to your service address';
  return (
    <Box>
      <Stack gap="30px">
        <Stack spacing={0.5} useFlexGap>
          <Stack direction="row" alignItems="center" gap="6px">
            <Typography className="CheckoutReadOnlyLabel" sx={{ fontWeight: 700, fontSize: '14px' }}>
              Installation Method
            </Typography>
            <InfoOutlinedIcon variant="readOnlyInfoIcon" />
          </Stack>
          <Typography className="CheckoutReadOnlyValue">{methodLabel}</Typography>
        </Stack>

        {savedValues?.selectedTimeSlot && (
          <Stack spacing={0.5} useFlexGap>
            <Typography className="CheckoutReadOnlyLabel" sx={{ fontWeight: 700, fontSize: '14px' }}>
              Scheduled Installation Date
            </Typography>
            <Typography className="CheckoutReadOnlyValue">
              {getInstallationDateLabel(isSelf, savedValues.selectedTimeSlot)}
            </Typography>
          </Stack>
        )}

        {!isSelf && (
          <>
            {restrictionDescription && (
              <InfoBannerBlock title="Important Instructions" description={restrictionDescription} />
            )}

            <Stack spacing={0.5} useFlexGap>
              <Typography className="CheckoutReadOnlyLabel" sx={{ fontWeight: 700, fontSize: '14px' }}>
                Notes for Your Technician
              </Typography>
              <Typography className="CheckoutReadOnlyValue">{savedValues?.specialInstructions || '---'}</Typography>
            </Stack>
          </>
        )}

        {isSelf && (
          <>
            <Stack spacing={0.5} useFlexGap>
              <Typography className="CheckoutReadOnlyLabel" sx={{ fontWeight: 700, fontSize: '14px' }}>
                How Would You Like to Receive Your Equipment?
              </Typography>
              <Typography className="CheckoutReadOnlyValue">{deliveryLabel}</Typography>
            </Stack>

            {savedValues?.hardwareDelivery === 'PICKUP' && (
              <InfoBannerBlock title="Pickup Location" description={displayPickupAddress || NOVUS_PICKUP_ADDRESS} />
            )}
          </>
        )}

        {isSelf && savedValues?.hardwareDelivery === 'DROPOFF' && (
          <>
            <InfoBannerBlock description={DROPOFF_NOTE_TEXT} />
            <Stack spacing={0.5} useFlexGap>
              <Typography className="CheckoutReadOnlyLabel" sx={{ fontWeight: 700, fontSize: '14px' }}>
                Delivery Instructions
              </Typography>
              <Typography className="CheckoutReadOnlyValue">{savedValues.deliveryInstructions || '---'}</Typography>
            </Stack>
          </>
        )}
      </Stack>
    </Box>
  );
};
